<script setup lang="ts">
type ListingFilterOption = {
	id: string;
	name: string;
};

type ListingFilterEntity = {
	id: string;
	name: string;
	shortName: string;
};

type ListingFilter = {
	label: string;
	code: string;
	id: string;
	name: string;
	options?: ListingFilterOption[];
	entities?: ListingFilterEntity[];
};

const emit = defineEmits<{
	(e: "selectFilterValue", { code, value }: { code: string; value: string }): void;
}>();

defineProps<{
	filter: ListingFilter;
	selectedOptionIds: string[];
}>();

const getOptions = (filter: ListingFilter) => {
	if ("options" in filter && !!filter.options) {
		return filter.options;
	}
	if ("entities" in filter && !!filter.entities) {
		return filter.entities;
	}
	return [];
};

const getLabel = (option: ListingFilterOption | ListingFilterEntity) => {
	if (!option) return "";

	if ("shortName" in option && !!option.shortName) {
		return option.shortName;
	}
	return option.name || "Onbekend";
};
</script>
<template>
	<Divider />

	<div class="flex flex-col gap-4">
		<span class="font-medium">{{ filter.label }}</span>
		<div class="flex flex-wrap gap-2">
			<KippieCheckbox
				v-for="option in getOptions(filter)"
				:key="option.id"
				:value="!!selectedOptionIds?.includes(option.id)"
				:label="getLabel(option)"
				@update="emit('selectFilterValue', { code: filter.code, value: option.id })"
			/>
		</div>
	</div>
</template>
